import type { FilterState, SegmentCollection, TakeoverCollection } from './types'

export const DEFAULT_FILTERS: FilterState = {
  trustTiers: ['high_trust', 'driven'],
  regions: [],
  sources: [],
  showTakeover: true,
  showFsdMarkets: true,
}

export function filterSegments(
  collection: SegmentCollection,
  filters: FilterState,
): SegmentCollection {
  return {
    type: 'FeatureCollection',
    features: collection.features.filter((f) => {
      const p = f.properties
      if (!filters.trustTiers.includes(p.trust)) return false
      if (filters.regions.length > 0 && p.region && !filters.regions.includes(p.region)) {
        return false
      }
      if (filters.sources.length > 0 && !p.sources.some((s) => filters.sources.includes(s))) {
        return false
      }
      return true
    }),
  }
}

export function filterTakeoverPoints(
  collection: TakeoverCollection,
  filters: FilterState,
): TakeoverCollection {
  if (!filters.showTakeover) {
    return { type: 'FeatureCollection', features: [] }
  }
  return collection
}

export function uniqueRegions(collection: SegmentCollection): string[] {
  const set = new Set<string>()
  for (const f of collection.features) {
    if (f.properties.region) set.add(f.properties.region)
  }
  return [...set].sort()
}

export function uniqueSources(collection: SegmentCollection): string[] {
  const set = new Set<string>()
  for (const f of collection.features) {
    for (const s of f.properties.sources) set.add(s)
  }
  return [...set].sort()
}